// You can write more code here

/* START OF COMPILED CODE */

import EntityMoney from "./EntityMoney";
/* START-USER-IMPORTS */
import { app } from '../../../core/App';
import { Sounds } from '../../../sounds';
import { SoundBanks } from "../../../sound-banks";
import { GameDataHandler } from '../../GameDataHandler';
import { VehicleVillain } from '../../vehicle/VehicleVillain';
/* END-USER-IMPORTS */

export default class MoneyBills extends EntityMoney {

  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 38, y ?? 26.5);

    // shadow
    const shadow = scene.add.image(0, 0, "game", "cash-shadow.png");
    this.add(shadow);

    // money
    const money = scene.add.image(4, -15, "game", "cash.png");
    this.add(money);

    this.shadow = shadow;
    this.money = money;

    /* START-USER-CTR-CODE */
    this.boundsExtension = 20;
    this.setSize(this.shadow.width, this.shadow.height);
    this.injectMatter(this, this.x, this.y, this.shadow.width + this.boundsExtension, this.shadow.height + this.boundsExtension);
    /* END-USER-CTR-CODE */
  }

  private shadow: Phaser.GameObjects.Image;
  private money: Phaser.GameObjects.Image;

  /* START-USER-CODE */

  public dropMoney(vehicle: VehicleVillain) {
    const randomSound = Phaser.Math.Between(0, SoundBanks.MoneyThrow.length - 1);
    app.audioHandler.playSound(this.scene, SoundBanks.MoneyThrow[randomSound], Sounds.Channel.SFX, { volume: 0.3 });
    this.throwTo(vehicle, this.money, this.shadow);
  }

  protected score(): void {
    app.audioHandler.playSound(this.scene, Sounds.Track.Pickup1, Sounds.Channel.SFX);
    this.scene.registry.inc(GameDataHandler.keys.Score, 1);
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
